import { memo } from 'react';
import {
  capitalizeFirstLetter,
  lineHeightStyle,
  styledComponent,
} from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';

const SurgicalView = ({
  selectedHistories,
  setSelectedHistories,
  prescriptionItems,
  isDelBtn = true,
}) => {
  let { surgical } = selectedHistories || {};

  // const clearData = (itemName) => {
  //   switch (itemName) {
  //     case 'lucs':
  //       surgical[itemName] = '';
  //       surgical['lucsStatus'] = '';
  //       break;
  //     case 'appendicectomy':
  //       surgical[itemName] = '';
  //       surgical['appendicectomyStatus'] = '';
  //       break;
  //     case 'cholecystectomy':
  //       surgical[itemName] = '';
  //       surgical['cholecystectomyStatus'] = '';
  //       break;
  //     case 'laparotomy':
  //       surgical[itemName] = '';
  //       surgical['laparotomyStatus'] = '';
  //       break;
  //     case 'laparoscopy':
  //       surgical[itemName] = '';
  //       surgical['laparoscopyStatus'] = '';
  //       break;
  //     case 'tah':
  //       surgical[itemName] = '';
  //       surgical['tahStatus'] = '';
  //       break;
  //     case 'ulso':
  //       surgical[itemName] = '';
  //       surgical['ulsoStatus'] = '';
  //       break;
  //     case 'dlso':
  //       surgical[itemName] = '';
  //       surgical['dlsoStatus'] = '';
  //       break;
  //     case 'others':
  //       surgical[itemName] = '';
  //       surgical['othersStatus'] = '';
  //       break;
  //     default:
  //   }
  //   selectedHistories['surgical'] = surgical;
  //   setSelectedHistories({ ...selectedHistories });
  // };

  const clearData = (itemName) => {
    const updatedSurgical = { ...surgical };

    const statusFieldsMap = {
      lucs: 'lucsStatus',
      appendicectomy: 'appendicectomyStatus',
      cholecystectomy: 'cholecystectomyStatus',
      laparotomy: 'laparotomyStatus',
      laparoscopy: 'laparoscopyStatus',
      tah: 'tahStatus',
      ulso: 'ulsoStatus',
      dlso: 'dlsoStatus',
      others: 'othersStatus',
    };

    if (statusFieldsMap[itemName]) {
      updatedSurgical[itemName] = '';
      updatedSurgical[statusFieldsMap[itemName]] = '';
    }

    setSelectedHistories({
      ...selectedHistories,
      surgical: updatedSurgical,
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  return (
    <div className="breast-exam-view">
      <div className="">S/H</div>
      <ul style={lineHeightStyle('history', prescriptionItems)}>
        {(surgical?.lucsStatus || surgical?.lucs) && (
          <li>
            <span className="text-left pr-5">
              <Title>LUCS: {capitalizeFirstLetter(surgical?.lucsStatus)}</Title>
              {surgical?.lucs && <Value> - {surgical?.lucs}</Value>}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'lucs'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.appendicectomyStatus || surgical?.appendicectomy) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                Appendicectomy:{' '}
                {capitalizeFirstLetter(surgical?.appendicectomyStatus)}
              </Title>
              {surgical?.appendicectomy && (
                <Value> - {surgical?.appendicectomy}</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'appendicectomy'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.cholecystectomyStatus || surgical?.cholecystectomy) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                Cholecystectomy:{' '}
                {capitalizeFirstLetter(surgical?.cholecystectomyStatus)}
              </Title>
              {surgical?.cholecystectomy && (
                <Value> - {surgical?.cholecystectomy}</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'cholecystectomy'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.laparotomyStatus || surgical?.laparotomy) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                Laparotomy: {capitalizeFirstLetter(surgical?.laparotomyStatus)}
              </Title>
              {surgical?.laparotomy && (
                <Value> - {surgical?.laparotomy}</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'laparotomy'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.laparoscopyStatus || surgical?.laparoscopy) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                Laparoscopy: {capitalizeFirstLetter(surgical?.laparoscopyStatus)}
              </Title>
              {surgical?.laparoscopy && (
                <Value> - {surgical?.laparoscopy}</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'laparoscopy'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.tahStatus || surgical?.tah) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                Total Abdominal History (TAH):{' '}
                {capitalizeFirstLetter(surgical?.tahStatus)}
              </Title>
              {surgical?.tah && <Value> - {surgical?.tah}</Value>}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'tah'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.ulsoStatus || surgical?.ulso) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                TAH With BLSO: {capitalizeFirstLetter(surgical?.ulsoStatus)}
              </Title>
              {surgical?.ulso && <Value> - {surgical?.ulso}</Value>}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'ulso'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.dlsoStatus || surgical?.dlso) && (
          <li>
            <span className="text-left pr-5">
              <Title>
                TLH With BLSO: {capitalizeFirstLetter(surgical?.dlsoStatus)}
              </Title>
              {surgical?.dlso && <Value> - {surgical?.dlso}</Value>}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'dlso'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(surgical?.othersStatus || surgical?.others) && (
          <li>
            <span className="text-left pr-5">
              <Title>Others: {capitalizeFirstLetter(surgical?.othersStatus)}</Title>
              {surgical?.others && (
                <Value> - {surgical?.others}</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'others'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(SurgicalView);
